// extracted by mini-css-extract-plugin
export var active = "_wy-1";
export var container = "_wy-0";
export var icon = "_wy-2";